import styles from './_index.module.scss';

const Footer = () => {
  const footerText = 'Powered by Numerator OmniPanel';

  return <div className={styles['footer']}>{footerText}</div>;
};

export default Footer;
